<template>
    <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
        <div slot="modal-header" class="w-100">
            <h5>Update Patient<button type="button" class="close"
                        @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span></button>
            </h5>
        </div>
        <b-form>
        <div class="container-fluid">
            <div class="row">
                <div class="col-2">
                    <img class="headshot" v-show="patientImageUrl" :src="patientImageUrl">
                </div>
                <div class="col-8">
                    <b-form-group label-cols="4"
                                  invalid-feedback="First Name is required"
                                  label="First Name"
                                  label-class="text-right">
                        <b-form-input v-model="patient.firstName"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="4"
                                  invalid-feedback="Last Name is required"
                                  label="Last Name"
                                  label-class="text-right">
                        <b-form-input v-model="patient.lastName"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="4"
                                  invalid-feedback="Birth date is not valid"
                                  label="Birth Date"
                                  label-class="text-right">
                        <datepicker format="MM/dd/yyyy" :use-utc="true" :typeable="true" class="form-control datepicker" v-model="patient.dob"></datepicker>
                    </b-form-group>
                    <b-form-group label-cols="4"
                                  invalid-feedback="Email is required"
                                  label="Email"
                                  label-class="text-right">
                        <b-form-input v-model="patient.email"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="4"
                                  invalid-feedback="Mobile phone is required"
                                  label="Mobile Phone"
                                  label-class="text-right">
                        <b-form-input @input="numberInput" :value="phoneDisplay"></b-form-input>
                    </b-form-group>
                </div>
            </div>
        </div>
        </b-form>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-orange float-right" @click.prevent="savePatient()"><font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner"  pulse/>Save</button>
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  import api from '../services/api'
  import moment from 'moment'
  import Datepicker from 'vuejs-datepicker'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EditPatientModal',

    components: { Datepicker },

    mixins: [AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      id: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        patient: {},
        patientImageUrl: '',
        isSaving: false
      }
    },

    watch: {
      id (newValue, oldValue) {
        this.clearPatientData()
        this.loadPatient()
      },

      visible (newValue) {
        if (newValue) {
          this.loadPatient()
        } else {
          this.clearPatientData()
        }
      }
    },

    computed: {
      phoneDisplay () {
        if (this.patient.mobileArea) {
          if (this.patient.mobileNumber.length > 0) {
            return '(' + this.patient.mobileArea + ') ' + this.patient.mobileExchange + '-' + this.patient.mobileNumber
          } else if (this.patient.mobileExchange.length > 0) {
            return '(' + this.patient.mobileArea + ') ' + this.patient.mobileExchange
          } else if (this.patient.mobileArea.length > 0) {
            return '(' + this.patient.mobileArea
          }
        }
        return ''
      }
    },

    methods: {
      clearPatientData () {
        this.patientImageUrl = ''
        this.patient = {}
      },

      loadPatient () {
        if (!this.id) {
          this.clearPatientData()
          return
        }

        api.get('/Dashboard/PatientDetail/' + this.id).then(response => {
          this.trackEvent('Patient', 'EditModalLoad', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Patient', 'EditModal', 'Loaded', this.id)

          this.patient = response.data
          this.patientImageUrl = response.data.imageUrl

        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Patient', 'EditModalLoadError', error.message)
            this.$log.error('Error attempting to load patient: ' + error.message, error)
          }
        })
      },

      numberInput (value) {
        const newNumber = value
        let cleanNumber = newNumber.replace(/\D/g, '')
        if (cleanNumber.length > 0) {
          if (parseInt(cleanNumber[0]) === 1) {
            cleanNumber = cleanNumber.substr(1, cleanNumber.length - 1)
          }

          this.patient.mobileArea = cleanNumber.substr(0, cleanNumber.length > 3 ? 3 : cleanNumber.length)
          if (cleanNumber.length > 3) {
            this.patient.mobileExchange = cleanNumber.substr(3, cleanNumber.length > 6 ? 3 : cleanNumber.length - 3)
          } else {
            this.patient.mobileExchange = ''
          }
          if (cleanNumber.length > 6) {
            this.patient.mobileNumber = cleanNumber.substr(6, cleanNumber.length < 10 ? cleanNumber.length - 6 : 4)
          } else {
            this.patient.mobileNumber = ''
          }
        } else {
          this.patient.mobileArea = ''
          this.patient.mobileExchange = ''
          this.patient.mobileNumber = ''
        }

      },

      savePatient () {
        if (this.isSaving) {
          return
        }

        this.isSaving = true
        api.post('/Dashboard/PatientDetail/' + this.patient.organizationPatientId, this.patient).then(response => {
          this.trackEvent('Patient', 'EditModalSave', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Patient', 'EditModal', 'Saved', this.id)

          this.patient = response.data
          this.patientImageUrl = response.data.imageUrl

          this.$emit('patientUpdated', this.patient)

        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Patient', 'EditModalSaveError', error.message)
            this.$log.error('Error attempting to load patient: ' + error.message, error)
          }
        }).then(() => {
          this.isSaving = false
        })
      },

      closeModal () {
        this.trackEvent('Patient', 'EditModal', 'Closed')
        this.$emit('update:visible', false)
      },

      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      }
    },

    created () {
    }
  }
</script>

<style scoped>
    .selectable-entry {
        border: 1px solid #dee2e6;
        background-color: #f9f9f9;
        padding: .5em;
    }

    .selectable-entry:HOVER {
        background-color: white;
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    .selectable-entry .fa-trash-alt, .selectable-entry .fa-edit {
        cursor: pointer;
    }

    .selectable-entry .fa-trash-alt:HOVER, .selectable-entry .fa-edit:HOVER {
        color: rgb(255, 70, 0);
    }

</style>
